import { useEffect, useRef } from 'react';
import { useStore } from '@/hooks/useStore';
import { flowResult } from 'mobx';
import { getStorage } from '@/utils/browsers';
import { keyStorage } from '@/configs/constants';

type Props = {
    children: React.ReactNode,
    minutes?: number
};

export default function AutoRefreshToken({ children, minutes = 30 }: Props) {
    const timerRef = useRef<NodeJS.Timeout>();
    const lastHiddenTime = useRef<number | null>(null);
    const timeout = minutes * 60 * 1000;
    const {
        authStore: { refreshTokenGG }
    } = useStore();

    useEffect(() => {
        const interval = setInterval(() => {
            const state = getStorage(keyStorage.STATE);
            const token = getStorage(keyStorage.TOKEN);
            if (state && token) {
                flowResult(refreshTokenGG());
            }
        }, timeout);

        return () => clearInterval(interval);
    }, [timeout]);
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                lastHiddenTime.current = Date.now();
            } else {
                if (
                    lastHiddenTime.current &&
                    Date.now() - lastHiddenTime.current > timeout
                ) {
                    const state = getStorage(keyStorage.STATE);
                    const token = getStorage(keyStorage.TOKEN);
                    if (state && token) {
                        flowResult(refreshTokenGG());
                    }
                } else {
                }
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [timeout]);

    return <>{children}</>;
}
